export default {
    stars: []
};
